<template>
    <v-tooltip :text="text">
        <template v-slot:activator="{ props }">
            <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
    </v-tooltip>
</template>
<style scoped>
</style>
<script>
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "HelpHover",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            text: String
        },
        methods: {
        },
        computed: {
        }
    };
</script>